import apayImage from '@/assets/pay/apay_166_120.png';
import bitImage from '@/assets/pay/bit_166_120.png';
import gpayImage from '@/assets/pay/gpay_166_120.png';
import masterImage from '@/assets/pay/master_166_120.png';
import paypalImage from '@/assets/pay/paypal_300.png';
import visaImage from '@/assets/pay/visa_166_120.png';
import type { PaymentOptionType } from '@hunk/shared/common';

import { cn } from '@/lib/utils';

/** the logos of a payment option (same images as bb-auth) */
export function PaymentOptionIcon({ option, className }: { option: PaymentOptionType; className?: string }) {
  // fixed box per logo (inline size, so the logos never render at their natural 166-300 px size)
  const img = (src: string, alt: string, extra?: string) => (
    <img
      src={src}
      alt={alt}
      width={42}
      height={28}
      style={{ width: 42, height: 28, maxWidth: 42 }}
      className={cn('block shrink-0 rounded-[4px] object-contain', extra)}
      draggable={false}
    />
  );
  return (
    <span className={cn('inline-flex shrink-0 items-center gap-1 overflow-hidden', className)} style={{ height: 28 }} dir="ltr">
      {option === 'cc' && (
        <>
          {img(visaImage, 'Visa')}
          {img(masterImage, 'Mastercard')}
        </>
      )}
      {option === 'paypal' && img(paypalImage, 'PayPal', 'bg-white')}
      {option === 'bit' && img(bitImage, 'Bit')}
      {option === 'apay' && img(apayImage, 'Apple Pay')}
      {option === 'gpay' && img(gpayImage, 'Google Pay')}
    </span>
  );
}
